import Homepage from './Homepage';
import schema from './props-schema';

Homepage.schema = schema;

// https://github.com/webpack/webpack/issues/706
export default Homepage;
